<template>
    <div class="c-header-msg" id="c-header-msg">
        <el-tooltip effect="dark" content="消息中心" placement="bottom" popper-class="c-header-tooltip">
            <a class="u-msg" :href="url">
                <i class="u-icon u-icon-msg">
                    <i class="u-pop" style="display: none" v-show="pop"></i>
                    <svg fill="#fff" height="512" viewBox="0 0 32 32" width="512" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M27.943 22.07l-.601-1a8.354 8.354 0 01-1.191-4.298v-5.52C26.151 5.654 21.598 1.1 16 1.1S5.849 5.654 5.849 11.251v5.52c0 1.514-.412 3-1.191 4.298l-.601 1.001a2.556 2.556 0 00-.033 2.603 2.555 2.555 0 002.249 1.311h19.455c.943 0 1.784-.49 2.249-1.311a2.558 2.558 0 00-.034-2.603zm-1.533 1.716a.77.77 0 01-.682.398H6.272a.768.768 0 01-.682-.398.768.768 0 01.01-.789l.601-1a10.154 10.154 0 001.448-5.225v-5.52C7.648 6.646 11.395 2.9 16 2.9s8.352 3.747 8.352 8.352v5.52c0 1.84.5 3.647 1.448 5.225l.601 1a.77.77 0 01.009.789zM19.087 27.758c-.657.84-1.811 1.342-3.087 1.342s-2.43-.502-3.087-1.342a.901.901 0 00-1.418 1.11C12.49 30.14 14.175 30.9 16 30.9s3.51-.76 4.505-2.033a.901.901 0 00-.154-1.264.903.903 0 00-1.264.155z"/></svg>
                </i>
            </a>
        </el-tooltip>
    </div>
</template>

<script>
import { __Links } from "@jx3box/jx3box-common/data/jx3box.json";
import { getMsg } from "../../service/header";
export default {
    name: "message",
    data: function () {
        return {
            url: __Links.dashboard.msg,
            pop: false,
        };
    },
    mounted() {
        this.checkMSG();
    },
    methods: {
        // 消息
        checkMSG: function () {
            getMsg().then((res) => {
                this.pop = !!(Math.max(~~res.data.data.letter, 0) + ~~res.data.data.message);
            });
        },
    },
};
</script>

<style lang="less">
//消息面板
.c-header-msg {
    position: relative;
    height: 100%;

    .u-msg {
        .h(100%);
        .flex;
        align-items: center;

        padding: 0 10px;
        &:hover {
            opacity: 0.7;
        }
        cursor: pointer;
    }
    .u-icon-msg {
        // .mt(10px);
        width: 17px;
        height: 17px;
        display: block;
        .pr;
        top: 1px;
        // margin-top: 9px;
        svg {
            width: 100%;
            height: 100%;
        }
        .pr;
    }
    .u-pop {
        width: 10px;
        height: 10px;
        color: #fff;
        background-image: linear-gradient(#54a3ff, #006eed);
        background-clip: padding-box;
        border: 2px solid #24292e;
        border-radius: 50%;
        position: absolute;
        right: -5px;
        top: -6px;
    }
}

@media screen and (max-width: @ipad) {
    .c-header-msg {
        display: none;
    }
}
</style>
